module.exports = __webpack_public_path__ + "static/img/MR.1a177776.svg";